// packages/shared/src/rules/shop.ts
import { itemsOfKind, tuning, type CatalogId, type ItemEntry } from '@whiskerton/content';
import type { DayKey } from '../types/ids';
import type { TownTime } from '../types/time';
import { rngFrom } from '../rng';
import { catalogLookup, type Lookup } from './lookup';

const defaultPool = (): ItemEntry[] => [...itemsOfKind('furniture'), ...itemsOfKind('wallpaper'), ...itemsOfKind('floor')];

/** Seed ('shop', townSeed, dayKey) (§7.6). Ids are sorted before shuffling, so the pool's order never matters. */
export function dailyStock(townSeed: number, dayKey: DayKey, pool: readonly ItemEntry[] = defaultPool()): CatalogId[] {
  const rng = rngFrom('shop', townSeed, dayKey);
  const pick = (kind: 'furniture' | 'wallpaper' | 'floor', n: number) =>
    rng.shuffle(pool.filter((e) => e.kind === kind && 'dailyStock' in e && e.dailyStock).map((e) => e.id).sort()).slice(0, n);
  return [...pick('furniture', tuning.shop.dailyFurniture), ...pick('wallpaper', tuning.shop.dailyWallpaper), ...pick('floor', tuning.shop.dailyFloor)];
}
export function alwaysStock(): CatalogId[] { return [...tuning.shop.always]; }
export function buyPrice(catalogId: CatalogId, lookup: Lookup = catalogLookup): number {
  const e = lookup(catalogId);
  return e && 'buy' in e && typeof e.buy === 'number' ? e.buy : 0;
}
export function isShopOpen(t: TownTime): boolean { return t.hour >= tuning.shop.openHour && t.hour < tuning.shop.closeHour; }
